import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { LoginModalTypeEnum } from '../login.enum'
import { LoginModalCommonProps } from '../login.types'
import LoginModalContainer from '../login-modal-container/login-modal-container'
import { breakpoints, useMediaQuery } from '../../../../lib/hooks'
import { Mixpanel } from '../../../../utils/Mixpanel'
import { pushToGTM } from '../../../../utils/pushToGTM'
import { Container } from '../../../layout'
import { ModalHelpMe } from '../../../molecules'

interface LoginModalSplittedContainerProps extends LoginModalCommonProps {
  isLoading?: boolean
  content: { left: JSX.Element | null; right: JSX.Element | null }
  buttonProps?: { onClick: () => void; disabled: boolean }
}
export const LoginModalSplittedContainer = ({
  isLoading,
  content,
  buttonProps,
  setModalType,
  modalType: { options },
}: LoginModalSplittedContainerProps) => {
  const intl = useIntl()
  const router = useRouter()
  const isMobile = useMediaQuery(breakpoints.newMobile)

  const [speakNowModal, setSpeakNowModal] = useState<boolean>(false)
  const [showHelpMe, setShowHelpMe] = useState<boolean>(false)

  const canCloseOnClickOutside = options?.canCloseOnClickOutside

  const closeModal = () => {
    if (canCloseOnClickOutside === false && !isMobile) {
      return
    }
    if (isMobile) {
      router.push('/')
    }
    pushToGTM({ event: 'closed-subscribe' })
    Mixpanel.track('Closed Subscribe', {
      type: 'modal',
    })
    if (isMobile) {
      setModalType({ type: LoginModalTypeEnum.Close })
    } else {
      pushToGTM({ event: 'opened-popup-demande' })
      setSpeakNowModal(true)
      setShowHelpMe(true)
    }
  }

  return (
    <>
      {speakNowModal ? (
        <ModalHelpMe
          speakNowModal={speakNowModal}
          setSpeakNowModal={setSpeakNowModal}
          showHelpMe={showHelpMe}
          setShowHelpMe={setShowHelpMe}
          onClose={() => setModalType({ type: LoginModalTypeEnum.Close })}
          style={{ backgroundColor: 'white' }}
          isAfterSignIn
        />
      ) : (
        <LoginModalContainer
          closeModal={closeModal}
          {...(isMobile
            ? {
                title: intl.formatMessage({
                  id: 'ui.LoginModalSplittedContainer.title.register',
                  defaultMessage: "S'inscrire sur Naboo",
                }),
                styleChildrenModal: { paddingTop: 10 },
              }
            : {
                style: {
                  maxHeight: 760,
                  maxWidth: 1000,
                  width: '70%',
                  height: 'auto',
                  borderRadius: '10px',
                },
              })}
          browserFooter={{
            onClick: () => {
              setModalType({ type: LoginModalTypeEnum.Login, options })
              pushToGTM({ event: 'closed-subscribe' })
            },
            label: (
              <FormattedMessage
                id='ui.LoginModalSplittedContainer.label.signIn'
                defaultMessage='Vous avez déjà un compte sur Naboo ? Connectez-vous.'
              />
            ),
            id: 'login-no-account',
          }}
          {...(buttonProps && {
            label: "S'inscrire",
            onClick: buttonProps.onClick,
            disabled: buttonProps.disabled,
            isLoading,
            id: 'finish-subscribe',
          })}
          styleContent={{ height: '100%' }}
          styleContainer={{
            padding: 0,
            height: '100%',
          }}
          noScroll={true}
        >
          <div className={s.subscribe}>
            {!isMobile ? (
              <>
                <Container
                  className={s.subscribeContainer}
                  styleContent={{ flex: 1 }}
                >
                  {content.left}
                </Container>
                <div className={s.separator} />
              </>
            ) : null}

            <Container
              className={s.subscribeContainer}
              styleContent={{ height: '100%' }}
            >
              {content.right}
            </Container>
          </div>
        </LoginModalContainer>
      )}
    </>
  )
}
